import { Textarea } from "@nextui-org/react";
import styled from "styled-components";

const StyledTextarea = styled(Textarea).attrs((props) => ({
  radius: props.radius ?? "lg",
}))``;

export default StyledTextarea;
